import React from 'react';
import PropTypes from 'prop-types';

const Reload = ({ colour, size }) =>
  (<svg
    width={size}
    height={size}
    viewBox="0 0 40 40"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g
      fill="none"
      fillRule="evenodd"
    >
      <path
        d="M8.89 26.803c3.804 6.088 11.824 7.94 17.913 4.135 6.088-3.804 7.94-11.825 4.135-17.913-3.804-6.09-11.825-7.94-17.913-4.136-6.09 3.804-7.94 11.824-4.136 17.913z"
        stroke={colour}
        strokeWidth="4"
        strokeLinecap="round"
        strokeDasharray="28,13"
      />
      <path
        // eslint-disable-next-line max-len
        d="M6 33.586V25c0-.552.448-1 1-1h8.586c.552 0 1 .448 1 1 0 .265-.106.52-.293.707l-8.586 8.586c-.39.39-1.024.39-1.414 0-.188-.188-.293-.442-.293-.707zM34 6.414V15c0 .552-.448 1-1 1h-8.586c-.552 0-1-.448-1-1 0-.265.106-.52.293-.707l8.586-8.586c.39-.39 1.024-.39 1.414 0 .188.188.293.442.293.707z"
        fill={colour}
      />
    </g>
  </svg>);

Reload.propTypes = {
  colour: PropTypes.string.isRequired,
  size: PropTypes.number.isRequired,
};

export default Reload;



// WEBPACK FOOTER //
// ./app/javascript/packs/Shared/components/Icon/Icons/Reload.jsx